<script>
  import { slide } from 'svelte/transition';
  import TwoStripes from '$lib/default/TwoStripes.svelte';

  export let properties;

  let propsOpen = false;

  let copied = false;

  function handleCopySingle() {
    // Get child text
    const text = this.querySelector('span').innerText;
    copyText(text);

    const smallBtns = document.querySelectorAll('.properties-list__item-copy');
    smallBtns.forEach((btn) => {
      if (btn.classList.contains('copied')) {
        btn.classList.remove('copied');
      }
    });

    const largeBtn = document.querySelector('.dropdown__btn');
    if (largeBtn.classList.contains('copied')) {
      largeBtn.classList.remove('copied');
    }

    const btn = this.querySelector('.properties-list__item-copy');
    btn.classList.add('copied');
  }

  function handleCopyAll() {
    const items = document.querySelectorAll('.properties-list li');
    if (!items.length) return;

    // Collect all item texts and join with new lines
    const text = Array.from(items)
      .map((item) => {
        const name =
          item.querySelector('.properties-list__item-name')?.innerText.trim() ||
          '';
        const value =
          item
            .querySelector('.properties-list__item-value span')
            ?.innerText.trim() || '';
        return `${name}: ${value}`;
      })
      .join('\n');

    copyText(text);

    const allBtns = document.querySelectorAll('.properties-list__item-copy');
    allBtns.forEach((btn) => {
      if (btn.classList.contains('copied')) {
        btn.classList.remove('copied');
      }
    });
    this.classList.add('copied');
  }

  /**
   * Copy text to clipboard
   * @param text
   */

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch((err) => {
        console.error('Clipboard write failed:', err);
      });
    } else {
      // Fallback for older browsers
      const textarea = document.createElement('textarea');
      textarea.value = text;
      document.body.appendChild(textarea);
      textarea.select();
      document.execCommand('copy');
      document.body.removeChild(textarea);
    }
  }
</script>

<div class="dropdown">
  <button
    class="btn btn-icon dropdown__toggle"
    on:click={() => {
      propsOpen = !propsOpen;
    }}
  >
    <i
      class="isax isax-arrow-down-1 dropdown__toggle-icon"
      style={propsOpen ? 'transform: rotate(180deg)' : ''}
    />
    <span class="dropdown__toggle-text tagline"
      >{properties.showPropertiesText}</span
    >
  </button>

  <div class="dropdown__content">
    {#if propsOpen}
      <div class="dropdown__box" transition:slide>
        <ul class="properties-list">
          {#each properties.items as item}
            <li>
              <button
                class="properties-list__item text-small"
                on:click={handleCopySingle}
              >
                <div class="properties-list__item-name">
                  {item.name}
                </div>
                <div class="properties-list__item-value">
                  <span>
                    {item.value}
                  </span>
                </div>

                <div
                  class="btn btn-icon properties-list__item-copy"
                  class:copied
                >
                  <i class="isax isax-copy" />
                </div>
              </button>
            </li>
          {/each}
        </ul>
        <div class="dropdown__btn-wrapper">
          <button
            class="btn btn-icon text-small dropdown__btn"
            class:copied
            on:click={handleCopyAll}
          >
            <i class="isax isax-copy" />

            <span class="tagline dropdown__btn-text">{properties.btnText}</span>
          </button>
        </div>
        <div class="dropdown__two-stripes">
          <TwoStripes />
        </div>
      </div>
    {/if}
  </div>
</div>

<style lang="scss">
  .dropdown {
    margin-top: 7rem;

    display: flex;
    flex-direction: column;
    align-items: center;

    &__toggle {
      &-icon {
        transition: transform 0.2s;
      }

      &-text {
        font-weight: 700;
      }
    }

    &__content {
      margin-top: 3rem;
    }

    &__box {
      padding: 4rem 5rem;

      border-radius: 2rem;
      background-color: rgb(var(--white));
      box-shadow: 3px 3px 0 rgba(var(--black), 0.02);
      position: relative;
    }

    &__btn-wrapper {
      text-align: center;
    }
    &__btn {
      margin: 3rem auto;
      border: 1px solid $light-border;
      border-radius: 30px;
      padding: 1rem 2rem;
      gap: 0.8rem;
      transition: all 0.3s;

      &-text {
        font-weight: 700;
      }

      &:hover {
        border-color: var(--grey);
        padding: 1rem 2.5rem;
      }

      &.copied {
        animation: change 0.7s ease-in-out forwards;
      }
    }

    &__two-stripes {
      position: absolute;
      bottom: 0;
      right: 4.7rem;

      @include resp-max('m') {
        right: 50%;
        transform: translate(50%);
        max-width: 2.1rem;
      }
    }
  }

  .properties-list {
    border-bottom: 1px solid $light-border;
    padding-bottom: 3rem;
    li {
      margin: 0.75rem 0;

      @include resp-max('s') {
        margin: 1.5rem 0;
      }
    }

    &__item {
      font-weight: 500;

      @include resp-max('s') {
        display: flex;
        column-gap: 2rem;
        row-gap: 0.5rem;
        flex-wrap: wrap;
      }

      &-name {
        color: var(--royal-light);
        width: 23rem;
        display: inline-block;

        @include resp-max('s') {
          width: 15rem;
        }
      }

      &-value {
        width: 25rem;
        display: inline-block;
      }

      &-copy {
        border: 1px solid $light-border;
        border-radius: 30px;
        padding: 0.5rem 1.5rem;
        transition: all 0.3s;

        @include resp-max('s') {
          order: -1;
        }

        &:hover {
          border-color: var(--grey);
        }

        &.copied {
          animation: change 0.7s ease-in-out forwards;
        }
      }
    }
  }

  @keyframes change {
    0% {
      background: transparent;
      transform: scale(1);
    }

    50% {
      background: var(--aqua-1);
    }

    85% {
      transform: scale(1.08);
    }

    100% {
      transform: translateY(1);
      background: var(--aqua-2);
    }
  }
</style>
